import type { MapLayer } from "../layers/types";
import type { MapEnginePlugin } from "../types/MapTypes";

export const ENGINE_REGISTRY: MapEnginePlugin[] = [
  { type: "openlayers", label: "OpenLayers", icon: "🗺", description: "OpenLayers 2D vector & raster" },
  { type: "leaflet", label: "Leaflet", icon: "🍃", description: "Leaflet.js lightweight 2D" },
  { type: "maplibre", label: "MapLibre GL", icon: "✦", description: "WebGL vector tiles", supports3D: true },
  { type: "cesium", label: "Cesium", icon: "🌐", description: "CesiumJS 3D globe", supports3D: true },
];

export const LABEL_CORECTION = [
  "case",
  // 1. Kiểm tra nếu bất kỳ trường tên nào chứa giá trị không mong muốn
  [
    "any",
    ["==", ["get", "name:vi"], "Tam Sa"],
    ["==", ["get", "name:en"], "Sansha"],
    ["==", ["get", "name"], "Sansha"],
    ["==", ["get", "name:zh"], "三沙"],
  ],
  "Quần đảo Hoàng Sa", // Thay thế bằng tên đúng

  [
    "any",
    ["==", ["get", "name:vi"], "Nam Sa"],
    ["==", ["get", "name:vi"], "Quận Nam Sa"],
    ["==", ["get", "name:en"], "Nansha"],
    ["==", ["get", "name"], "Nansha"],
    ["==", ["get", "name:zh"], "南沙"],
  ],
  "Quần đảo Trường Sa", // Thay thế bằng tên đúng

  // 2. Nếu không rơi vào các trường hợp trên, hiển thị theo ưu tiên ngôn ngữ
  //["coalesce", ["get", "name:vi"], ["get", "name:en"], ["get", "name"]],
  ["get", "name:vi"],
];

export const BASEMAPS: MapLayer | any = [
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-light-global",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#cccccc",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#e2dfda",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        id: "landcover",
        paint: {
          "fill-color": [
            "match",
            ["get", "kind"],
            "grassland",
            "rgba(210, 239, 207, 1)",
            "barren",
            "rgba(255, 243, 215, 1)",
            "urban_area",
            "rgba(230, 230, 230, 1)",
            "farmland",
            "rgba(216, 239, 210, 1)",
            "glacier",
            "rgba(255, 255, 255, 1)",
            "scrub",
            "rgba(234, 239, 210, 1)",
            "rgba(196, 231, 210, 1)",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 5, 1, 7, 0],
        },
        source: "protomaps",
        "source-layer": "landcover",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#9cd3b4",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#a0d9a0",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#99d2bb",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#e7e7e7",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#e2e0d7",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#c6dcdc",
            "#e2dfda",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#9cd3b4",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#e4dad9",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#d1dde1",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#e4ded7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#e8e4d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#c6dcdc",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#dadbdf",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#e9e9ed",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#e9e9ed",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#e9e9ed",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#80deea",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#80deea",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#80deea",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#e3e0d4",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#e0e0e0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d5d5d5",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#cccccc",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#ebebeb",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#ffffff"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#a7b1b3",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#91888b",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#91888b",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#938a8d",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: [
          "all",
          [
            "in",
            ["get", "kind"],
            [
              "literal",
              [
                "beach",
                "forest",
                "marina",
                "park",
                "peak",
                "zoo",
                "garden",
                "bench",
                "aerodrome",
                "station",
                "bus_stop",
                "ferry_terminal",
                "stadium",
                "university",
                "library",
                "school",
                "animal",
                "toilets",
                "drinking_water",
              ],
            ],
          ],
          [">=", ["zoom"], ["+", ["get", "min_zoom"], 0]],
        ],
        id: "pois",
        layout: {
          "icon-image": ["match", ["get", "kind"], "station", "train_station", ["get", "kind"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-justify": "auto",
          "text-max-width": 8,
          "text-offset": [1.1, 0],
          "text-size": ["interpolate", ["linear"], ["zoom"], 17, 10, 19, 16],
          "text-variable-anchor": ["left", "right"],
        },
        paint: {
          "text-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["beach", "forest", "marina", "park", "peak", "zoo", "garden", "bench"]]],
            "#20834D",
            ["in", ["get", "kind"], ["literal", ["aerodrome", "station", "bus_stop", "ferry_terminal"]]],
            "#315BCF",
            ["in", ["get", "kind"], ["literal", ["stadium", "university", "library", "school", "animal", "toilets", "drinking_water"]]],
            "#6A5B8F",
            "#e2dfda",
          ],
          "text-halo-color": "#e2dfda",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "pois",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b3b3b3",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#a3a3a3",
          "text-halo-color": "#e2dfda",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/global/global_20250905.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/light",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_light_global.png",
    title: "Light Map Global",
    name: "Light Map Global",
    type: "raster",
    usedForAdmin: true,
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-dark-global",
    layers: [
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#1f1f1f",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        id: "landcover",
        paint: {
          "fill-color": [
            "match",
            ["get", "kind"],
            "grassland",
            "rgba(30, 41, 31, 1)",
            "barren",
            "rgba(38, 38, 36, 1)",
            "urban_area",
            "rgba(28, 28, 28, 1)",
            "farmland",
            "rgba(31, 36, 32, 1)",
            "glacier",
            "rgba(43, 43, 43, 1)",
            "scrub",
            "rgba(34, 36, 30, 1)",
            "rgba(28, 41, 37, 1)",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 5, 1, 7, 0],
        },
        source: "protomaps",
        "source-layer": "landcover",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#192a24",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#202121",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#222323",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#1c1c1c",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#212123",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#222323",
            "#1f1f1f",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#192a24",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#252424",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#222222",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#262323",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#28282a",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#222323",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#1e1e1e",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#31353f",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#31353f",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#31353f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#1e1e1e",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#111111",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#333333",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#3d3d3d", 16, "#333333"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#474747",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#000000",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#5b6374",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#5b6374",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#2b2b2b",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#474747",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["get", "name:en"],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#666666",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: [
          "all",
          [
            "in",
            ["get", "kind"],
            [
              "literal",
              [
                "beach",
                "forest",
                "marina",
                "park",
                "peak",
                "zoo",
                "garden",
                "bench",
                "aerodrome",
                "station",
                "bus_stop",
                "ferry_terminal",
                "stadium",
                "university",
                "library",
                "school",
                "animal",
                "toilets",
                "drinking_water",
              ],
            ],
          ],
          [">=", ["zoom"], ["+", ["get", "min_zoom"], 0]],
        ],
        id: "pois",
        layout: {
          "icon-image": ["match", ["get", "kind"], "station", "train_station", ["get", "kind"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-justify": "auto",
          "text-max-width": 8,
          "text-offset": [1.1, 0],
          "text-size": ["interpolate", ["linear"], ["zoom"], 17, 10, 19, 16],
          "text-variable-anchor": ["left", "right"],
        },
        paint: {
          "text-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["beach", "forest", "marina", "park", "peak", "zoo", "garden", "bench"]]],
            "#30C573",
            ["in", ["get", "kind"], ["literal", ["aerodrome", "station", "bus_stop", "ferry_terminal"]]],
            "#2B5CEA",
            ["in", ["get", "kind"], ["literal", ["stadium", "university", "library", "school", "animal", "toilets", "drinking_water"]]],
            "#93939F",
            "#1f1f1f",
          ],
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "pois",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#3d3d3d",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#212121",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> Â© <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/global/global_20250905.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/dark",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_dark_global.png",
    title: "Dark Map Global",
    name: "Dark Map Global",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-dark-viz-global",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#2b2b2b",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#141414",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#181818",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#1a1a1a",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#1c1c1c",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#191919",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#161616",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#191919",
            "#141414",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#181818",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#1d1d1d",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#101010",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#111111",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#1f1f1f",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#323232",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#323232",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#323232",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#333333",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#0a0a0a",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#101010",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#0a0a0a",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#0a0a0a",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#1f1f1f",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#292929", 16, "#1f1f1f"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#707070",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#707070",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#3d3d3d",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/global/global_20250905.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/black",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_dark_viz_global.png",
    title: "Dark Viz Map Global",
    name: "Dark Viz Map Global",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-dark-viz-vn",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#2b2b2b",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#141414",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#181818",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#1a1a1a",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#1c1c1c",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#191919",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#161616",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#191919",
            "#141414",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#181818",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#1d1d1d",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#101010",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#111111",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#1f1f1f",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#323232",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#323232",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#323232",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#333333",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#191919",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#0a0a0a",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#101010",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#101010",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#0a0a0a",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#0a0a0a",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#1f1f1f",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#292929", 16, "#1f1f1f"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#707070",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#707070",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#333333",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#3d3d3d",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#707070",
          "text-halo-color": "#141414",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/vietnam/vietnam.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/black",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_dark_viz.jpg",
    title: "Dark Viz Map VN",
    name: "Dark Viz Map VN",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-dark-vn",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#34373d",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#1f1f1f",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        id: "landcover",
        paint: {
          "fill-color": [
            "match",
            ["get", "kind"],
            "grassland",
            "rgba(30, 41, 31, 1)",
            "barren",
            "rgba(38, 38, 36, 1)",
            "urban_area",
            "rgba(28, 28, 28, 1)",
            "farmland",
            "rgba(31, 36, 32, 1)",
            "glacier",
            "rgba(43, 43, 43, 1)",
            "scrub",
            "rgba(34, 36, 30, 1)",
            "rgba(28, 41, 37, 1)",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 5, 1, 7, 0],
        },
        source: "protomaps",
        "source-layer": "landcover",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#192a24",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#202121",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#222323",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#1c1c1c",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#212123",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#222323",
            "#1f1f1f",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#192a24",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#252424",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#222222",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#262323",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#28282a",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#222323",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#1e1e1e",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#31353f",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#31353f",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#31353f",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#1e1e1e",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#333333",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#141414",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#141414",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#292929",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#292929",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#111111",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#333333",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#3d3d3d", 16, "#333333"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#474747",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#000000",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#5b6374",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#5b6374",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#2b2b2b",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#333333",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#3d3d3d",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#1f1f1f",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#474747",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": ["get", "name:en"],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#717784",
          "text-halo-color": "#31353f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#666666",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: [
          "all",
          [
            "in",
            ["get", "kind"],
            [
              "literal",
              [
                "beach",
                "forest",
                "marina",
                "park",
                "peak",
                "zoo",
                "garden",
                "bench",
                "aerodrome",
                "station",
                "bus_stop",
                "ferry_terminal",
                "stadium",
                "university",
                "library",
                "school",
                "animal",
                "toilets",
                "drinking_water",
              ],
            ],
          ],
          [">=", ["zoom"], ["+", ["get", "min_zoom"], 0]],
        ],
        id: "pois",
        layout: {
          "icon-image": ["match", ["get", "kind"], "station", "train_station", ["get", "kind"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-justify": "auto",
          "text-max-width": 8,
          "text-offset": [1.1, 0],
          "text-size": ["interpolate", ["linear"], ["zoom"], 17, 10, 19, 16],
          "text-variable-anchor": ["left", "right"],
        },
        paint: {
          "text-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["beach", "forest", "marina", "park", "peak", "zoo", "garden", "bench"]]],
            "#30C573",
            ["in", ["get", "kind"], ["literal", ["aerodrome", "station", "bus_stop", "ferry_terminal"]]],
            "#2B5CEA",
            ["in", ["get", "kind"], ["literal", ["stadium", "university", "library", "school", "animal", "toilets", "drinking_water"]]],
            "#93939F",
            "#1f1f1f",
          ],
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "pois",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#525252",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#3d3d3d",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#212121",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#1f1f1f",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> Â© <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/vietnam/vietnam.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/dark",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_dark.jpg",
    title: "Dark Map VN",
    name: "Dark Map VN",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-gray-global",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#a3a3a3",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#cccccc",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#d2d2d2",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#d2d2d2",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#c7c7c7",
            "#cccccc",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#c2c2c2",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#d0d0d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#c6c6c6",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#d0d0d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#d2d2d2",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#c7c7c7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#c9c9c9",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#f5f5f5",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#a3a3a3",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#a3a3a3",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#a3a3a3",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#c4c4c4",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#b8b8b8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#e0e0e0",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#b8b8b8",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#e0e0e0"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#5c5c5c",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#5c5c5c",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ebebeb",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#474747",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#858585",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/global/global_20250905.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/grayscale",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_gray_viz_global.png",
    title: "Gray Map Global",
    name: "Gray Map Global",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-gray-vn",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#a3a3a3",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#cccccc",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#c2c2c2",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#d2d2d2",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#d2d2d2",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#c7c7c7",
            "#cccccc",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#c2c2c2",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#d0d0d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#c6c6c6",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#d0d0d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#d2d2d2",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#c7c7c7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#c9c9c9",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#f5f5f5",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#a3a3a3",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#a3a3a3",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#a3a3a3",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#c4c4c4",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#b8b8b8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#b8b8b8",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#e0e0e0",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#b8b8b8",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#e0e0e0"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#5c5c5c",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#5c5c5c",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#cccccc",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#a3a3a3",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ebebeb",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#7a7a7a",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#474747",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#858585",
          "text-halo-color": "#cccccc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/vietnam/vietnam.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/grayscale",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_gray_viz.jpg",
    title: "Gray Map VN",
    name: "Gray Map VN",
    type: "raster",
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-light-viz-global",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#ffffff",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#ffffff",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#fcfcfc",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#fcfcfc",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#f7f7f7",
            "#ffffff",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#fcfcfc",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#f8f8f8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#fcfcfc",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#f8f8f8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#f6f6f6",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#f7f7f7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#fdfdfd",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#efefef",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#dcdcdc",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#dcdcdc",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#dcdcdc",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#fdfdfd",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#efefef",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#d6d6d6",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#efefef",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#f5f5f5"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b3b3b3",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b8b8b8",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/global/global_20250905.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/white",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_light_viz_global.png",
    title: "Light Viz Map Global",
    name: "Light Viz Map Global",
    type: "raster",
    usedForAdmin: false,
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-light-viz-vn",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#ffffff",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#ffffff",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#fcfcfc",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#fcfcfc",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#fafafa",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#f7f7f7",
            "#ffffff",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#fcfcfc",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#f8f8f8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#fcfcfc",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#f8f8f8",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#f6f6f6",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#f7f7f7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#fdfdfd",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#efefef",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#dcdcdc",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#dcdcdc",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#dcdcdc",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#fdfdfd",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#efefef",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#d6d6d6",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#fcfcfc",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d6d6d6",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#efefef",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#efefef",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#f5f5f5"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#d6d6d6",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#adadad",
          "text-halo-color": "#dcdcdc",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#999999",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b3b3b3",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b8b8b8",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/vietnam/vietnam.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/white",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_light_viz.jpg",
    title: "Light Viz Map VN",
    name: "Light Viz Map VN",
    type: "raster",
    usedForAdmin: false,
    version: 8,
    visibility: true,
  },
  {
    glyphs: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/fonts/{fontstack}/{range}.pbf",
    id: "basemap-light-vn",
    layers: [
      {
        id: "background",
        paint: {
          "background-color": "#cccccc",
        },
        type: "background",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "earth",
        paint: {
          "fill-color": "#e2dfda",
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "fill",
      },
      {
        id: "landcover",
        paint: {
          "fill-color": [
            "match",
            ["get", "kind"],
            "grassland",
            "rgba(210, 239, 207, 1)",
            "barren",
            "rgba(255, 243, 215, 1)",
            "urban_area",
            "rgba(230, 230, 230, 1)",
            "farmland",
            "rgba(216, 239, 210, 1)",
            "glacier",
            "rgba(255, 255, 255, 1)",
            "scrub",
            "rgba(234, 239, 210, 1)",
            "rgba(196, 231, 210, 1)",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 5, 1, 7, 0],
        },
        source: "protomaps",
        "source-layer": "landcover",
        type: "fill",
      },
      {
        filter: [
          "in",
          "kind",
          "national_park",
          "park",
          "cemetery",
          "protected_area",
          "nature_reserve",
          "forest",
          "golf_course",
          "wood",
          "nature_reserve",
          "forest",
          "scrub",
          "grassland",
          "grass",
          "military",
          "naval_base",
          "airfield",
        ],
        id: "landuse_park",
        paint: {
          "fill-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["national_park", "park", "cemetery", "protected_area", "nature_reserve", "forest", "golf_course"]]],
            "#9cd3b4",
            ["in", ["get", "kind"], ["literal", ["wood", "nature_reserve", "forest"]]],
            "#a0d9a0",
            ["in", ["get", "kind"], ["literal", ["scrub", "grassland", "grass"]]],
            "#99d2bb",
            ["in", ["get", "kind"], ["literal", ["glacier"]]],
            "#e7e7e7",
            ["in", ["get", "kind"], ["literal", ["sand"]]],
            "#e2e0d7",
            ["in", ["get", "kind"], ["literal", ["military", "naval_base", "airfield"]]],
            "#c6dcdc",
            "#e2dfda",
          ],
          "fill-opacity": ["interpolate", ["linear"], ["zoom"], 6, 0, 11, 1],
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "allotments", "village_green", "playground"],
        id: "landuse_urban_green",
        paint: {
          "fill-color": "#9cd3b4",
          "fill-opacity": 0.7,
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "hospital"],
        id: "landuse_hospital",
        paint: {
          "fill-color": "#e4dad9",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "industrial"],
        id: "landuse_industrial",
        paint: {
          "fill-color": "#d1dde1",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "school", "university", "college"],
        id: "landuse_school",
        paint: {
          "fill-color": "#e4ded7",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "beach"],
        id: "landuse_beach",
        paint: {
          "fill-color": "#e8e4d0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "zoo"],
        id: "landuse_zoo",
        paint: {
          "fill-color": "#c6dcdc",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["in", "kind", "aerodrome"],
        id: "landuse_aerodrome",
        paint: {
          "fill-color": "#dadbdf",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "runway"],
        id: "roads_runway",
        paint: {
          "line-color": "#e9e9ed",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 10, 0, 12, 4, 18, 30],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind_detail", "taxiway"],
        id: "roads_taxiway",
        minzoom: 13,
        paint: {
          "line-color": "#e9e9ed",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 15, 6],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["any", ["in", "kind", "runway", "taxiway"]],
        id: "landuse_runway",
        paint: {
          "fill-color": "#e9e9ed",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "$type", "Polygon"],
        id: "water",
        paint: {
          "fill-color": "#80deea",
        },
        source: "protomaps",
        "source-layer": "water",
        type: "fill",
      },
      {
        filter: ["in", "kind", "stream"],
        id: "water_stream",
        minzoom: 14,
        paint: {
          "line-color": "#80deea",
          "line-width": 0.5,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "river"],
        id: "water_river",
        minzoom: 9,
        paint: {
          "line-color": "#80deea",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1, 18, 12],
        },
        source: "protomaps",
        "source-layer": "water",
        type: "line",
      },
      {
        filter: ["in", "kind", "pedestrian", "dam"],
        id: "landuse_pedestrian",
        paint: {
          "fill-color": "#e3e0d4",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["==", "kind", "pier"],
        id: "landuse_pier",
        paint: {
          "fill-color": "#e0e0e0",
        },
        source: "protomaps",
        "source-layer": "landuse",
        type: "fill",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [3, 2],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_tunnels_highway_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-dasharray": [6, 0.5],
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["in", "kind", "other", "path"]],
        id: "roads_tunnels_other",
        paint: {
          "line-color": "#d5d5d5",
          "line-dasharray": [4.5, 0.5],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "minor_road"]],
        id: "roads_tunnels_minor",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["has", "is_link"]],
        id: "roads_tunnels_link",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", "kind", "major_road"]],
        id: "roads_tunnels_major",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_tunnel"], ["==", ["get", "kind"], "highway"], ["!", ["has", "is_link"]]],
        id: "roads_tunnels_highway",
        paint: {
          "line-color": "#d5d5d5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["in", "kind", "building", "building_part"],
        id: "buildings",
        paint: {
          "fill-color": "#cccccc",
          "fill-opacity": 0.5,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
      },
      {
        filter: ["==", "kind_detail", "pier"],
        id: "roads_pier",
        paint: {
          "line-color": "#e0e0e0",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 0.5, 20, 16],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service_casing",
        minzoom: 13,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor_casing",
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link_casing",
        minzoom: 13,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_late",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["in", "kind", "other", "path"], ["!=", "kind_detail", "pier"]],
        id: "roads_other",
        paint: {
          "line-color": "#ebebeb",
          "line-dasharray": [3, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["has", "is_link"],
        id: "roads_link",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["==", "kind_detail", "service"]],
        id: "roads_minor_service",
        paint: {
          "line-color": "#ebebeb",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 18, 8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "minor_road"], ["!=", "kind_detail", "service"]],
        id: "roads_minor",
        paint: {
          "line-color": ["interpolate", ["exponential", 1.6], ["zoom"], 11, "#ebebeb", 16, "#ffffff"],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 13],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_major",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway_casing_early",
        maxzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["!has", "is_tunnel"], ["!has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_highway",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "rail"],
        id: "roads_rail",
        paint: {
          "line-color": "#a7b1b3",
          "line-dasharray": [0.3, 0.75],
          "line-opacity": 0.5,
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 0.15, 18, 9],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["<=", "kind_detail", 2],
        id: "boundaries_country",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.7,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: [">", "kind_detail", 2],
        id: "boundaries",
        paint: {
          "line-color": "#adadad",
          "line-dasharray": ["step", ["zoom"], ["literal", [2, 0]], 4, ["literal", [2, 1]]],
          "line-width": 0.4,
        },
        source: "protomaps",
        "source-layer": "boundaries",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 12, 0, 12.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 0.8],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 0.5, 18, 10],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 9, 0, 9.5, 1.5],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["in", "kind", "other", "path"]],
        id: "roads_bridges_other",
        minzoom: 12,
        paint: {
          "line-color": "#ebebeb",
          "line-dasharray": [2, 1],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 14, 0, 20, 7],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "minor_road"]],
        id: "roads_bridges_minor",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 11, 0, 12.5, 0.5, 15, 2, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["has", "is_link"]],
        id: "roads_bridges_link",
        minzoom: 12,
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 13, 0, 13.5, 1, 18, 11],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "major_road"]],
        id: "roads_bridges_major",
        minzoom: 12,
        paint: {
          "line-color": "#f5f5f5",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 6, 0, 12, 1.6, 15, 3, 18, 13],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway_casing",
        minzoom: 12,
        paint: {
          "line-color": "#e0e0e0",
          "line-gap-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 3.5, 0.5, 18, 15],
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 7, 0, 7.5, 1, 20, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["all", ["has", "is_bridge"], ["==", "kind", "highway"], ["!has", "is_link"]],
        id: "roads_bridges_highway",
        paint: {
          "line-color": "#ffffff",
          "line-width": ["interpolate", ["exponential", 1.6], ["zoom"], 3, 0, 6, 1.1, 12, 1.6, 15, 5, 18, 15],
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "line",
      },
      {
        filter: ["==", "kind", "address"],
        id: "address_label",
        layout: {
          "symbol-placement": "point",
          "text-field": ["get", "addr_housenumber"],
          "text-font": ["Noto Sans Italic"],
          "text-size": 12,
        },
        minzoom: 18,
        paint: {
          "text-color": "#91888b",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "buildings",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "river", "stream"],
        id: "water_waterway_label",
        layout: {
          "symbol-placement": "line",
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.2,
          "text-size": 12,
        },
        minzoom: 13,
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["==", ["get", "oneway"], "yes"],
        id: "roads_oneway",
        layout: {
          "icon-image": "arrow",
          "icon-rotate": 90,
          "symbol-placement": "line",
          "symbol-spacing": 100,
        },
        minzoom: 16,
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "minor_road", "other", "path"],
        id: "roads_labels_minor",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 15,
        paint: {
          "text-color": "#91888b",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "sea", "ocean", "bay", "strait", "fjord"],
        id: "water_label_ocean",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 10, 12],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "island"],
        id: "earth_label_islands",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 8,
          "text-size": 10,
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "earth",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "lake", "water"],
        id: "water_label_lakes",
        layout: {
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Italic"],
          "text-letter-spacing": 0.1,
          "text-max-width": 9,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 10, 6, 12, 10, 12],
        },
        paint: {
          "text-color": "#728dd4",
          "text-halo-color": "#80deea",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "water",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "highway", "major_road"],
        id: "roads_labels_major",
        layout: {
          "symbol-placement": "line",
          "symbol-sort-key": ["get", "min_zoom"],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-size": 12,
        },
        minzoom: 11,
        paint: {
          "text-color": "#938a8d",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "roads",
        type: "symbol",
      },
      {
        filter: [
          "all",
          [
            "in",
            ["get", "kind"],
            [
              "literal",
              [
                "beach",
                "forest",
                "marina",
                "park",
                "peak",
                "zoo",
                "garden",
                "bench",
                "aerodrome",
                "station",
                "bus_stop",
                "ferry_terminal",
                "stadium",
                "university",
                "library",
                "school",
                "animal",
                "toilets",
                "drinking_water",
              ],
            ],
          ],
          [">=", ["zoom"], ["+", ["get", "min_zoom"], 0]],
        ],
        id: "pois",
        layout: {
          "icon-image": ["match", ["get", "kind"], "station", "train_station", ["get", "kind"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-justify": "auto",
          "text-max-width": 8,
          "text-offset": [1.1, 0],
          "text-size": ["interpolate", ["linear"], ["zoom"], 17, 10, 19, 16],
          "text-variable-anchor": ["left", "right"],
        },
        paint: {
          "text-color": [
            "case",
            ["in", ["get", "kind"], ["literal", ["beach", "forest", "marina", "park", "peak", "zoo", "garden", "bench"]]],
            "#20834D",
            ["in", ["get", "kind"], ["literal", ["aerodrome", "station", "bus_stop", "ferry_terminal"]]],
            "#315BCF",
            ["in", ["get", "kind"], ["literal", ["stadium", "university", "library", "school", "animal", "toilets", "drinking_water"]]],
            "#6A5B8F",
            "#e2dfda",
          ],
          "text-halo-color": "#e2dfda",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "pois",
        type: "symbol",
      },
      {
        filter: ["in", "kind", "neighbourhood", "macrohood"],
        id: "places_subplace",
        layout: {
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-letter-spacing": 0.1,
          "text-max-width": 7,
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 2, 8, 4, 12, 18, 15, 20],
          "text-size": ["interpolate", ["exponential", 1.2], ["zoom"], 11, 8, 14, 14, 18, 24],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#8f8f8f",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "region"],
        id: "places_region",
        layout: {
          "symbol-sort-key": ["get", "sort_key"],
          "text-anchor": "center",
          "text-field": [
            "step",
            ["zoom"],
            ["coalesce", ["get", "ref:en"], ["get", "ref"]],
            6,
            [
              "case",
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["has", "script"],
                [
                  "case",
                  ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                    {},
                    "",
                    {},
                    [
                      "case",
                      ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                      "",
                      ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    ],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["get", "name:en"],
                ],
                ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
              ],
              [
                "all",
                ["any", ["has", "name"], ["has", "pgf:name"]],
                ["any", ["has", "name2"], ["has", "pgf:name2"]],
                ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["has", "script2"],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
              [
                "case",
                ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
                [
                  "format",
                  ["get", "name:vi"],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "case",
                  ["!", ["has", "script"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  ["!", ["has", "script2"]],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script3"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                  [
                    "format",
                    ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                    {},
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                    "",
                    {},
                    ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                    {
                      "text-font": [
                        "case",
                        ["==", ["get", "script2"], "Devanagari"],
                        ["literal", ["Noto Sans Devanagari Regular v1"]],
                        ["literal", ["Noto Sans Regular"]],
                      ],
                    },
                  ],
                ],
              ],
            ],
          ],
          "text-font": ["Noto Sans Regular"],
          "text-radial-offset": 0.2,
          "text-size": ["interpolate", ["linear"], ["zoom"], 3, 11, 7, 16],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#b3b3b3",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "locality"],
        id: "places_locality",
        layout: {
          "icon-image": ["step", ["zoom"], ["case", ["==", ["get", "capital"], "yes"], "capital", "townspot"], 8, ""],
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 0, 8, 4, 10, 8, 12, 6, 22, 2],
          "icon-size": 0.7,
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": [
            "case",
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["!", ["any", ["has", "name2"], ["has", "pgf:name2"]]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["has", "script"],
              [
                "case",
                ["any", ["is-supported-script", ["get", "name"]], ["has", "pgf:name"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "name:en"]],
                  {},
                  "",
                  {},
                  [
                    "case",
                    ["all", ["!", ["has", "name:vi"]], ["has", "name:en"], ["!", ["has", "script"]]],
                    "",
                    ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  ],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["get", "name:en"],
              ],
              ["format", ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]], {}],
            ],
            [
              "all",
              ["any", ["has", "name"], ["has", "pgf:name"]],
              ["any", ["has", "name2"], ["has", "pgf:name2"]],
              ["!", ["any", ["has", "name3"], ["has", "pgf:name3"]]],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["has", "script2"],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
            [
              "case",
              ["all", ["has", "script"], ["has", "script2"], ["has", "script3"]],
              [
                "format",
                ["get", "name:vi"],
                {},
                "",
                {},
                ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script2"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
                "",
                {},
                ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                {
                  "text-font": [
                    "case",
                    ["==", ["get", "script3"], "Devanagari"],
                    ["literal", ["Noto Sans Devanagari Regular v1"]],
                    ["literal", ["Noto Sans Regular"]],
                  ],
                },
              ],
              [
                "case",
                ["!", ["has", "script"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name"], ["get", "name"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                ["!", ["has", "script2"]],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name2"], ["get", "name2"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name3"], ["get", "name3"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script3"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
                [
                  "format",
                  ["coalesce", ["get", "name:vi"], ["get", "pgf:name3"], ["get", "name3"]],
                  {},
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name"], ["get", "name"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                  "",
                  {},
                  ["coalesce", ["get", "pgf:name2"], ["get", "name2"]],
                  {
                    "text-font": [
                      "case",
                      ["==", ["get", "script2"], "Devanagari"],
                      ["literal", ["Noto Sans Devanagari Regular v1"]],
                      ["literal", ["Noto Sans Regular"]],
                    ],
                  },
                ],
              ],
            ],
          ],
          "text-font": ["case", ["<=", ["get", "min_zoom"], 5], ["literal", ["Noto Sans Medium"]], ["literal", ["Noto Sans Regular"]]],
          "text-justify": "auto",
          "text-padding": ["interpolate", ["linear"], ["zoom"], 5, 3, 8, 7, 12, 11],
          "text-radial-offset": 0.3,
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 13], 8, [">=", ["get", "population_rank"], 13], 13, 0],
            4,
            ["case", ["<", ["get", "population_rank"], 13], 10, [">=", ["get", "population_rank"], 13], 15, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 12], 11, [">=", ["get", "population_rank"], 12], 17, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 11], 11, [">=", ["get", "population_rank"], 11], 18, 0],
            10,
            ["case", ["<", ["get", "population_rank"], 9], 12, [">=", ["get", "population_rank"], 9], 20, 0],
            15,
            ["case", ["<", ["get", "population_rank"], 8], 12, [">=", ["get", "population_rank"], 8], 22, 0],
          ],
          "text-variable-anchor": ["step", ["zoom"], ["literal", ["bottom", "left", "right", "top"]], 8, ["literal", ["center"]]],
        },
        paint: {
          "text-color": "#5c5c5c",
          "text-halo-color": "#e0e0e0",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
      {
        filter: ["==", "kind", "country"],
        id: "places_country",
        layout: {
          "icon-padding": ["interpolate", ["linear"], ["zoom"], 0, 2, 14, 2, 16, 20, 17, 2, 22, 2],
          "symbol-sort-key": ["case", ["has", "sort_key"], ["get", "sort_key"], ["get", "min_zoom"]],
          "text-field": ["format", ["coalesce", ["get", "name:vi"], ["get", "name:en"]], {}],
          "text-font": ["Noto Sans Medium"],
          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            2,
            ["case", ["<", ["get", "population_rank"], 10], 8, [">=", ["get", "population_rank"], 10], 12, 0],
            6,
            ["case", ["<", ["get", "population_rank"], 8], 10, [">=", ["get", "population_rank"], 8], 18, 0],
            8,
            ["case", ["<", ["get", "population_rank"], 7], 11, [">=", ["get", "population_rank"], 7], 20, 0],
          ],
          "text-transform": "uppercase",
        },
        paint: {
          "text-color": "#a3a3a3",
          "text-halo-color": "#e2dfda",
          "text-halo-width": 1,
        },
        source: "protomaps",
        "source-layer": "places",
        type: "symbol",
      },
    ],
    sources: {
      protomaps: {
        attribution: '<a href="https://github.com/protomaps/basemaps">Protomaps</a> © <a href="https://vegastar.com.vn/">VegaStar</a>',
        type: "vector",
        url: "pmtiles://https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/vietnam/vietnam.pmtiles",
      },
    },
    sprite: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/basemaps-assets/sprites/v4/light",
    thumbURL: "https://dev-s3.geohub.vn/test-gh-cdn/pmtiles/thumbnails/maplibre_light.jpg",
    title: "Light Map VN ",
    name: "Light Map VN",
    type: "raster",
    usedForAdmin: false,
    version: 8,
    visibility: true,
  },
];
